<template>
    <div 
        class="temporal-recon"
        :class="{ 'animate': doAnimate }"    
    >
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 682.9 682.9" style="enable-background:new 0 0 682.9 682.9;" xml:space="preserve">
            <circle id="bg" cx="341.5" cy="342.9" r="316.1"/>
            <g id="outer-ring">
                <path class="st0" d="M341.5,682.9c-91.2,0-176.9-35.5-241.4-100S0,432.6,0,341.5s35.5-177,100-241.4S250.2,0,341.5,0
                    s177,35.5,241.4,100s100,150.2,100,241.4s-35.5,177-100,241.4S432.7,682.9,341.5,682.9L341.5,682.9z M341.5,29.2
                    c-172.2,0-312.2,140.1-312.2,312.2s140.1,312.2,312.2,312.2s312.2-140.1,312.2-312.2S513.6,29.2,341.5,29.2z"/>
            </g>
            <path class="st1" d="M-422,205.1c4.5,0,8.1-3.6,8.1-8.1v-20c0-4.5-3.6-8.1-8.1-8.1h-217.3c-4.5,0-8.1,3.6-8.1,8.1v20
                c0,4.5,3.6,8.1,8.1,8.1h11.3v329.6h-11.3c-4.5,0-8.1,3.6-8.1,8.1v20c0,4.5,3.6,8.1,8.1,8.1H-422c4.5,0,8.1-3.6,8.1-8.1v-20
                c0-4.5-3.6-8.1-8.1-8.1h-8.7V205.1H-422z M-616.2,266c6.9,22.3,19.4,46.9,41.5,66.4c14.9,13.1,22.2,26.1,22,38.8
                c-0.7,11.8-8,24-21.9,36.2c-22.2,19.6-34.7,44.2-41.6,66.6V266z M-616.2,534.7v-42.1c0.1-0.7,0.2-1.3,0.4-2h-0.4v-1.5
                c5.6-25,17.8-55.6,44.2-78.8c15.8-13.9,23.6-27.9,23.3-41.7h-0.1c-0.7-13-8.5-26.1-23.2-39.1c-26.3-23.1-38.5-53.6-44.1-78.6v-1.7
                h0.4c-0.2-0.7-0.3-1.5-0.4-2.3v-41.8h173.9v47.9c-5.8,24.6-18.1,54-43.6,76.5c-14.8,13-22.6,26.1-23.2,39.1h-0.1
                c-0.3,13.8,7.5,27.8,23.3,41.7c25.6,22.6,37.9,52.1,43.7,76.7v47.7H-616.2z M-442.4,267.5v205c-7-22-19.4-46-41.1-65.1
                c-13.9-12.2-21.2-24.3-21.9-36.2c-0.3-12.6,7.1-25.7,22-38.8C-461.7,313.4-449.4,289.5-442.4,267.5z"/>
            <g id="moons">
                <circle class="st2" cx="66.2" cy="340.7" r="20.8"/>
                <circle class="st3" cx="607.3" cy="340.7" r="18.8"/>
                <path class="st2" d="M334.2,614.9c-1.8-8.8,3.9-17.3,12.7-19c1.5-0.3,2.9-0.4,4.4-0.3c-4.6-3.5-10.6-5.1-16.7-3.9
                    c-11.2,2.2-18.5,13.2-16.3,24.4s13.2,18.5,24.4,16.3c3.7-0.7,6.9-2.4,9.5-4.7C343.9,628.9,335.9,623.3,334.2,614.9z"/>
                <path class="st2" d="M339.1,60.4c1.8,8.8-3.9,17.3-12.7,19c-1.5,0.3-2.9,0.4-4.4,0.3c4.6,3.5,10.6,5.1,16.7,3.9
                    c11.2-2.2,18.5-13.2,16.3-24.4c-2.2-11.2-13.2-18.5-24.4-16.3c-3.7,0.7-6.9,2.4-9.5,4.7C329.5,46.4,337.4,51.9,339.1,60.4z"/>
            </g>
            <g id="lotus">
                <g style="animation-delay: 1s;">
                    <path class="st4" d="M338.7,340.1c0,0,77.8-148.7,287.4-64.6C626.1,275.4,493.1,450.4,338.7,340.1z"/>
                    <path class="st4" d="M336.9,339.9c0,0-77.8-148.7-287.4-64.6C49.5,275.3,182.5,450.2,336.9,339.9z"/>
                </g>
                <g style="animation-delay: 1.5s;">
                    <path class="st4" d="M335,342.3c0,0-77.8,148.7-287.4,64.6C47.6,407,180.6,232,335,342.3z"/>
                    <path class="st4" d="M336.8,342.5c0,0,77.8,148.7,287.4,64.6C624.2,407.1,491.2,232.2,336.8,342.5z"/>
                </g>
                <g style="animation-delay: 2s;">
                    <path class="st4" d="M343.5,350.3c0,0-28.1,165.5-253.3,150.3C90.2,500.6,162.6,293.2,343.5,350.3z"/>
                    <path class="st4" d="M581.8,499.4c0,0-28.1-165.5-253.3-150.3C328.5,349.1,400.9,556.6,581.8,499.4z"/>
                </g>
                <g style="animation-delay: 2.5s;">
                    <path class="st4" d="M346.2,327.8c0,0-28.1-165.5-253.3-150.3C92.8,177.5,165.2,385,346.2,327.8z"/>
                    <path class="st4" d="M584.5,189.1c0,0-28.1,165.5-253.3,150.3C331.1,339.4,403.6,131.9,584.5,189.1z"/>
                </g>
                <g style="animation-delay: 3s;">
                    <path class="st4" d="M348.2,348.6c0,0,37.6,163.6-176.3,236C171.8,584.6,159.1,365.2,348.2,348.6z"/>
                    <path class="st4" d="M325.8,347.9c0,0-37.6,163.6,176.3,236C502.1,583.8,514.8,364.5,325.8,347.9z"/>
                </g>
                <g style="animation-delay: 3.5s;">
                    <path class="st4" d="M349.5,337c0,0,37.6-163.6-176.3-236C173.2,101.1,160.5,320.4,349.5,337z"/>
                    <path class="st4" d="M327.1,337.8c0,0-37.6-163.6,176.3-236C503.4,101.8,516.1,321.2,327.1,337.8z"/>
                </g>
                <g style="animation-delay: 4s;">
                    <path class="st4" d="M335.1,340.9c0,0,100.1,134.8-66.8,286.9C268.2,627.8,168.6,432,335.1,340.9z"/>
                    <path class="st4" d="M331.2,341.3c0,0-100.1,134.8,66.8,286.9C398,628.2,497.7,432.4,331.2,341.3z"/>
                </g>
                <g style="animation-delay: 4.5s;">
                    <path class="st4" d="M339.4,343.6c0,0,100.1-134.8-66.8-286.9C272.6,56.7,173,252.6,339.4,343.6z"/>
                    <path class="st4" d="M335.6,343.2c0,0-100.1-134.8,66.8-286.9C402.4,56.3,502,252.2,335.6,343.2z"/>
                </g>
            </g>
            <g id="hourglass">
                <path d="M282,295.3c11.8,11.8,26.8,22.8,29.8,39.3c2,11.2-2.3,22.8-8.6,32.3c-6.3,9.5-14.6,17.5-21.8,26.3
                    c-19,23.2-30.6,52.4-32.6,82.4c-0.9,12.4,0.4,26.2,9.1,35c10.5,10.6,27.5,10.3,42.4,9.3c25.8-1.8,51.6-3.7,77.3-5.5
                    c17.2-1.2,36.4-3.5,47.1-16.9c12.2-15.3,7.4-38.3-2.6-55.1c-10.6-17.8-25.9-32.3-38.3-48.9c-12.4-16.6-22-37.1-18.4-57.5
                    c3.9-22.2,22.3-38.6,35.1-57.2c19.5-28.3,26.8-64.7,19.7-98.3c-2.2-10.3-49.8-18.8-58.7-20.3c-21.7-3.5-44.1-3.2-65.7,1.1
                    c-12.6,2.5-39.3,6.2-47,17.9c-8.9,13.4-3.3,42.2,0.2,56.7C254.5,258,265.8,279,282,295.3z"/>
                <path d="M258.8,378.4c0.1,11.8,0.8,25,9.4,33.1c9.7,9.3,25.1,7.9,38.4,5.9c28.7-4.3,57.4-8.6,86-12.9c9.5-1.4,19.6-3.2,26.5-9.9
                    c6.8-6.7,8.8-16.7,10.5-26c4.4-24.5,8.5-50.8-2.3-73.2c-12.8-26.5-44.1-40-73.6-40.2c-23.9-0.1-68.8,5.9-87,24.4
                    c-9.3,9.4-8.7,22.4-8.7,34.7C258.2,335.6,258.6,357,258.8,378.4z"/>
                <g>
                    <path d="M447.3,176.7c4.5,0,8.1-3.6,8.1-8.1v-20c0-4.5-3.6-8.1-8.1-8.1H230.1c-4.5,0-8.1,3.6-8.1,8.1v20c0,4.5,3.6,8.1,8.1,8.1
                        h11.3v329.6h-11.3c-4.5,0-8.1,3.6-8.1,8.1v20c0,4.5,3.6,8.1,8.1,8.1h217.3c4.5,0,8.1-3.6,8.1-8.1v-20c0-4.5-3.6-8.1-8.1-8.1h-8.7
                        V176.7H447.3z M253.1,237.5c6.9,22.3,19.4,46.9,41.5,66.4c14.9,13.1,22.2,26.1,22,38.8c-0.7,11.8-8,24-21.9,36.2
                        c-22.2,19.6-34.7,44.2-41.6,66.6V237.5z M253.1,506.2v-42.1c0.1-0.7,0.2-1.3,0.4-2h-0.4v-1.5c5.6-25,17.8-55.6,44.2-78.8
                        c15.8-13.9,23.6-27.9,23.3-41.7h-0.1c-0.7-13-8.5-26.1-23.2-39.1c-26.3-23.1-38.5-53.6-44.1-78.6v-1.7h0.4
                        c-0.2-0.7-0.3-1.5-0.4-2.3v-41.8h173.9v47.9c-5.8,24.6-18.1,54-43.6,76.5c-14.8,13-22.6,26.1-23.2,39.1H360
                        c-0.3,13.8,7.5,27.8,23.3,41.7c25.6,22.6,37.9,52.1,43.7,76.7v47.7H253.1z M426.9,239.1v205c-7-22-19.4-46-41.1-65.1
                        c-13.9-12.2-21.2-24.3-21.9-36.2c-0.3-12.6,7.1-25.7,22-38.8C407.6,284.9,419.9,261,426.9,239.1z"/>
                    <path d="M447.3,557.6H230.1c-12.8,0-23.1-10.4-23.1-23.1v-20c0-11.5,8.4-21.1,19.5-22.8V191.4c-11-1.8-19.5-11.3-19.5-22.8v-20
                        c0-12.8,10.4-23.1,23.1-23.1h217.3c12.8,0,23.1,10.4,23.1,23.1v20c0,10.6-7.1,19.5-16.9,22.3v301.3c9.7,2.7,16.9,11.7,16.9,22.3
                        v20C470.5,547.2,460.1,557.6,447.3,557.6z M243.4,527.6h194.4l-2-6.3H245.4L243.4,527.6z M236.9,527.6h1.1v-6.3h-1.1V527.6z
                        M268.1,491.2h143.9v-30.9c-6.9-28.2-19.9-50.8-38.6-67.2c-19.2-16.9-28.7-34.8-28.4-53.2l0.3-14.7h2.6
                        c4.1-12.1,12.6-24,25.5-35.3c18.6-16.4,31.6-38.9,38.5-67v-31.1H268.1v25.4c0,0.2,0.1,0.5,0.1,0.7l2.8,13.9
                        c7.3,24,19.5,43.5,36.1,58.1c12.9,11.4,21.4,23.2,25.5,35.3h2.5l0.4,14.7c0.4,18.4-9.2,36.3-28.4,53.2
                        c-16.9,14.9-29.1,34.8-36.4,59.2l-2.6,12.8c0,0.1-0.1,0.3-0.1,0.4V491.2z M268.1,298V385c5.1-6.3,10.6-12,16.7-17.4
                        c10.4-9.2,16.2-18,16.8-25.5c0-9.9-9.1-20.1-16.9-26.9C278.7,310,273.1,304.2,268.1,298z M378.9,342.1c0.6,7.5,6.4,16.3,16.8,25.5
                        c5.8,5.1,11.2,10.7,16.2,16.8v-85.9c-4.9,6-10.3,11.6-16.1,16.7C388.1,322.1,378.9,332.2,378.9,342.1z M245.2,161.7H436l2-6.3
                        H243.3L245.2,161.7z M236.9,161.7h1.1v-6.3h-1.1V161.7z"/>
                </g>
                <path class="st2" d="M447,175.7c4.5,0,8.1-3.6,8.1-8.1v-20c0-4.5-3.6-8.1-8.1-8.1H229.8c-4.5,0-8.1,3.6-8.1,8.1v20
                    c0,4.5,3.6,8.1,8.1,8.1h11.3v329.6h-11.3c-4.5,0-8.1,3.6-8.1,8.1v20c0,4.5,3.6,8.1,8.1,8.1H447c4.5,0,8.1-3.6,8.1-8.1v-20
                    c0-4.5-3.6-8.1-8.1-8.1h-8.7V175.7H447z M252.8,236.6c6.9,22.3,19.4,46.9,41.5,66.4c14.9,13.1,22.2,26.1,22,38.8
                    c-0.7,11.8-8,24-21.9,36.2c-22.2,19.6-34.7,44.2-41.6,66.6V236.6z M252.8,505.3v-42.1c0.1-0.7,0.2-1.3,0.4-2h-0.4v-1.5
                    c5.6-25,17.8-55.6,44.2-78.8c15.8-13.9,23.6-27.9,23.3-41.7h-0.1c-0.7-13-8.5-26.1-23.2-39.1c-26.3-23.1-38.5-53.6-44.1-78.6v-1.7
                    h0.4c-0.2-0.7-0.3-1.5-0.4-2.3v-41.8h173.9v47.9c-5.8,24.6-18.1,54-43.6,76.5c-14.8,13-22.6,26.1-23.2,39.1h-0.1
                    c-0.3,13.8,7.5,27.8,23.3,41.7c25.6,22.6,37.9,52.1,43.7,76.7v47.7H252.8z M426.6,238.1v205c-7-22-19.4-46-41.1-65.1
                    c-13.9-12.2-21.2-24.3-21.9-36.2c-0.3-12.6,7.1-25.7,22-38.8C407.3,283.9,419.6,260,426.6,238.1z"/>
                <g id="anim1" class="st5">
                    <path class="st6" d="M291.9,278.3c11.4,10.8,24.2,20.7,32.1,34.2c6.8,11.5,9.7,25.3,8.1,38.6c-0.7,5.7-2.2,11.6-0.5,17.2
                        c1.7,5.5,8.4,10,13.3,7c0.1-17.6,0.3-35.6,6-52.2c5.9-17.1,17.1-31.6,27.2-46.6s19.5-31.4,20.5-49.4c-5.8,6-15.6,5.9-23.4,3
                        c-7.8-2.9-14.6-8-22.3-11.2c-13.9-5.7-29.9-4.6-44.2,0.1c-8,2.6-15.6,6.3-23,10.4c-4.5,2.5-16.1,6.9-17.5,11.9
                        c-1.5,5.4,5.7,15.9,8.5,20C281.2,267.6,286.4,273.1,291.9,278.3z"/>
                    <path class="st6" d="M293.6,481.1c8.9-2.5,18.6-4.6,24.9-11.4c4.1-4.4,6.2-10.2,9.9-14.9s10.3-8.2,15.6-5.5
                        c5.1,2.6,6.2,9.2,9,14.3c9.6,17.7,39.3,15.5,48.5,33.4c-28.2,0.3-56.5,0.7-84.7,1c-7,0.1-14,0.2-21,0.3
                        c-4.2,0.1-15.1,2.2-18.5-0.4C267.1,489.9,289.1,482.4,293.6,481.1z"/>
                </g>
                <g id="anim2" class="st5">
                    <path class="st6" d="M313.5,301.7c10.7,8.3,21.4,19.8,20,33.2c-0.4,4.1-1.2,9.7,2.7,11.1c3.3,1.3,6.5-2.2,8.4-5.2
                        c6.6-10.5,13.3-21,19.9-31.5c12.3-19.5,24.6-39.1,34.2-60.1c-8.8,7-21.4,5.3-32.4,3c-11-2.3-23.3-4.7-32.8,1.4
                        c-4.3,2.7-7.9,7.1-12.9,7.6c-5.6,0.5-10.2-4.1-15.5-6.1c-10-3.6-26.2,6.3-20.5,17.3C290.7,284.7,303,293.5,313.5,301.7z"/>
                    <path class="st6" d="M344.7,366.6c-0.3,3.3-0.6,6.7,0.5,9.8c1.1,3.1,4.1,5.8,7.4,5.5c3.2-0.3,5.7-3.6,5.6-6.8s-2.2-6.2-5-7.8
                        c-2.8-1.6-6.2-2-9.4-1.9"/>
                    <path class="st6" d="M316.3,403.8c-2.2-1.3-4.8-2.4-7.4-2c-2.6,0.4-5,2.9-4.5,5.4c0.7,3.3,5,4.2,8.3,3.5c1.9-0.4,3.8-1.2,4.8-2.8
                        c1-1.6,0.4-4.2-1.5-4.7"/>
                    <path class="st6" d="M274.7,468.2c5.3-7.3,12.3-13.3,19.3-19.1c7.9-6.6,17.1-13.7,27.3-12.1c6.7,1,12.8,5.8,19.6,5
                        c9.1-1.1,14.4-11.5,23.2-13.7c5.5-1.4,11.5,0.8,15.9,4.5c4.4,3.7,7.5,8.6,10.5,13.5c4,6.7,7.9,13.4,11.6,20.2
                        c3.5,6.3,6.9,13.9,3.9,20.5c-3.5,8-13.9,9.7-22.5,10.2c-24.9,1.3-49.9,1.1-74.9-0.7c-11.4-0.8-26.4,0-37.2-3.9
                        C261.4,489,270.1,474.6,274.7,468.2z"/>
                </g>
                <g id="anim3" class="st5">
                    <path class="st6" d="M330.3,338.7c1.1,2.6,2.4,5.5,5,6.7c3.4,1.5,7.5-0.7,9.5-3.9c2-3.2,2.5-7,3.2-10.7
                        c3.2-15.5,12.6-29.7,25.7-38.6c-7.4,2-15.3,0-22.6-2.4c-7.3-2.4-14.8-5.1-22.5-4.4c-9.9,1-17,7.6-13.5,16.9
                        C319.9,314.5,325.2,326.6,330.3,338.7z"/>
                    <path class="st6" d="M308.7,409c6.7-7.5,13.4-15,20.2-22.5c2.4-2.7,4.9-5.4,8-7.1c3.2-1.7,7.2-2.2,10.3-0.3
                        c8,5,2.5,20.1,10.4,25.2c5,3.3,11.7,0,17.7,0.7c9.2,1.1,14.2,11.1,17.6,19.7c5,12.8,10.1,25.5,15.1,38.3c2.6,6.5,4.9,14.8,0,19.9
                        c-2,2.1-4.7,3.1-7.4,4c-30,10.3-62.4,13.6-93.9,9.6c-9.1-1.1-34.1-1.7-36.5-12.4c-2.6-11.5,4.9-29.3,9.7-39.4
                        C286.5,430.9,296.4,418.4,308.7,409z"/>
                </g>
            </g>
        </svg>
    </div>
</template>

<script>
export default {
  name: 'badge-6',
  data() {
    return {
            counter: 0,
            intervalId: null,
            doAnimate: false
        }
    },
    mounted() {
        this.intervalId = setInterval(() => {
            this.doAnimate = true
            
            setTimeout(() => {
                this.doAnimate = false
            }, 8000)
        }, 15000)

        this.doAnimate = true
        setTimeout(() => {
            this.doAnimate = false
        }, 5000)
    },
    beforeUnmount() {
        clearInterval(this.intervalId)
    },
}
</script>

<style scoped>
.st0{fill:#ED0000;}
.st1{fill:#FFFFFF;}
.st2{fill:#CC993E;}
.st3{fill:none;stroke:#CC993E;stroke-width:8;stroke-miterlimit:10;}
.st4{fill:none;stroke:#FFF;stroke-width:3;stroke-miterlimit:10;}
.st5{opacity:0;}
.st6{display:inline;fill:#CC993E;}

@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  50% {
    stroke-dashoffset: 10000;
  }
}

@keyframes flicker {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

#moons {
    opacity: 0.4;
}

.temporal-recon.animate #moons,
.temporal-recon:hover #moons {
    opacity: 1;
}

.temporal-recon #hourglass {
    opacity: 0;
    transition: all 2s;
}

.temporal-recon.animate #hourglass,
.temporal-recon:hover #hourglass {
    opacity: 1;
    animation: dripsand 10s infinite;
}

.temporal-recon #lotus {
    opacity: 0;
}

.temporal-recon.animate #lotus,
.temporal-recon:hover #lotus {
    /* animation: dash 30s; */
    stroke-dasharray: 10;
    animation-iteration-count: infinite;
    opacity: 0.7;
}

.temporal-recon.animate #lotus *,
.temporal-recon:hover #lotus * {
    animation: flicker 3s infinite;
}

#outer-ring * {
    fill: #CC993E;
    transition: all 0.5s;
}

.temporal-recon.animate #outer-ring *,
.temporal-recon:hover #outer-ring * {
    fill:#ED0000;
}

.temporal-recon.animate #anim1,
.temporal-recon:hover #anim1 {
    animation: flicker 2s alternate-reverse;
}

.temporal-recon.animate #anim2,
.temporal-recon:hover #anim2 {
    animation: flicker 2s alternate-reverse;
    animation-delay: 2s;
}

.temporal-recon.animate #anim3,
.temporal-recon:hover #anim3 {
    animation: flicker 2s alternate-reverse;
    animation-delay: 4s;
}
</style>